export const HERO_IMAGE_URL =
  'https://imagecdn.owenscorning.com/image/upload/v1721055144/roofing/roof-smart/roof-smarter-hero.png';

export const FOOTER_TEXT =
  "Replacing a roof is a process. This helpful checklist higlights the key steps in the journey to keep your roofing project on track. It's your Roof Smarter!";

export const TITLE = 'Is this your roof?';

export const DOWNLOAD_URL = 'https://www.owenscorning.com/dms/10027541';

export const TAG_LINE =
  "Here are a few common warning signs that your roof needs attention. Don't wait to contact us if this is your roof!";

export const PRODUCTS = [
  {
    url:
      'https://imagecdn.owenscorning.com/image/upload/v1721055144/roofing/roof-smart/shingle-streaks.png',
    title: 'Dark Streaks',
    description:
      'Airborne algae cause dark streaks on your roof. While not necessarily harmful, it may not look good.',
  },
  {
    url:
      'https://imagecdn.owenscorning.com/image/upload/v1721055144/roofing/roof-smart/missing-shingle.png',
    title: 'Strom Damage',
    description:
      'Are you missing shingles after high winds or seeing dents in your shingles from hail storms?',
  },
  {
    url:
      'https://imagecdn.owenscorning.com/image/upload/v1721055144/roofing/roof-smart/ice-dam.png',
    title: 'Ice Build-up',
    description:
      'This can be a sign of poor attic ventilation and can cause water damage to walls and ceilings.',
  },
];
